import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { facultiesApi } from "../../../services/nomenclatures/facultiesApi";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import { specialitiesApi } from "../../../services/nomenclatures/specialitiesApi";
import { groupsApi } from "../../../services/nomenclatures/groupsApi";
import { ProgressSpinner } from "primereact/progressspinner";
import { academicYearsApi } from "../../../services/nomenclatures/academicYearsApi";

const GroupGradesReport: React.FC = () => {
  const [facultyId, setFacultyId] = useState<number | null>(null);
  const [specialityId, setSpecialityId] = useState<number | null>(null);
  const [academicYearId, setAcademicYearId] = useState<number | null>(null);
  const [groupId, setGroupId] = useState<number | null>(null);
  const [semester, setSemester] = useState<number>(1);

  const { data: faculties } = facultiesApi.useGetFacultiesQuery();
  const { data: specialities } = specialitiesApi.useGetSpecialitiesQuery();
  const { data: academicYears } = academicYearsApi.useGetAcademicYearsQuery();
  const { data: groups } = groupsApi.useGetGroupsBySpecialityIdAndAcademicYearQuery(
    { specialityId: specialityId!, academicYearId: academicYearId! },
    { skip: !specialityId || !academicYearId }
  );

  const [triggerDownloadGroupGradesReport, { isLoading: isDownloadGroupGradesReportLoading }] =
    groupsApi.useLazyGetGroupGradesReportQuery();

  useEffect(() => {
    if (!specialityId || !academicYearId) {
      setGroupId(null);
    }
  }, [specialityId, academicYearId]);

  const semesters = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const handleDownloadExcel = async () => {
    try {
      const result = await triggerDownloadGroupGradesReport({
        facultyId: facultyId!,
        specialityId,
        groupId,
        semester,
        academicYearId,
      }).unwrap();
      console.log("Downloaded Excel:", result);
      const blob = new Blob([result.blob], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = result.fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return (
    <div className="flex justify-content-center flex-wrap">
      <Card className="w-full mt-4">
        <div className="flex justify-content-between align-items-center">
          <h4>Справка за оценки и заверки на студенти по групи</h4>
        </div>
        <Divider />
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-6">
            <label htmlFor="facultyId">Факултет</label>
            <Dropdown
              id="facultyId"
              options={faculties?.data ?? []}
              optionLabel="name"
              optionValue="facultyId"
              placeholder="Изберете факултет"
              value={facultyId}
              onChange={(e: DropdownChangeEvent) => setFacultyId(e.value)}
              required
              className="w-full"
            />
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="specialityId">Специалност</label>
            <Dropdown
              id="specialityId"
              options={specialities?.data.filter((s) => s.facultyId === facultyId) ?? []}
              optionLabel="name"
              optionValue="specialityId"
              placeholder="Изберете специалност"
              value={specialityId}
              onChange={(e: DropdownChangeEvent) => setSpecialityId(e.value)}
              required
              className="w-full"
            />
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="academicYearId">Академична година</label>
            <Dropdown
              id="academicYearId"
              options={academicYears?.data ?? []}
              optionLabel="name"
              optionValue="academicYearId"
              placeholder="Изберете академична година"
              value={academicYearId}
              onChange={(e: DropdownChangeEvent) => setAcademicYearId(e.value)}
              required
              className="w-full"
            />
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="groupId">Група</label>
            <Dropdown
              id="groupId"
              options={groups?.data ?? []}
              optionLabel="name"
              optionValue="groupId"
              placeholder="Изберете група"
              value={groupId}
              onChange={(e: DropdownChangeEvent) => setGroupId(e.value)}
              required
              className="w-full"
              disabled={!specialityId || !academicYearId}
            />
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="semester">Семестър</label>
            <Dropdown
              id="semester"
              options={semesters}
              placeholder="Изберете семестър"
              value={semester}
              onChange={(e: DropdownChangeEvent) => setSemester(e.value)}
              required
              className="w-full"
            />
          </div>
          <div className="field col-12">
            {isDownloadGroupGradesReportLoading && <ProgressSpinner />}
            <Button
              label="Генериране на справка"
              icon="pi pi-file-excel"
              className="p-button-success"
              onClick={handleDownloadExcel}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default GroupGradesReport;
